import TimingCityPicker from "@/components/panchang/TimingCityPicker";
import type { CityData } from "@/lib/cities-data.types";
import { TITHI_COPY, type TithiLanguage } from "../tithi-today.copy";

export default function TithiCityPicker({
  city,
  language,
  onCityChange,
}: {
  city: CityData;
  language: TithiLanguage;
  onCityChange: (city: CityData) => void;
}) {
  const copy = TITHI_COPY[language];

  return (
    <TimingCityPicker
      id="tithi-city"
      city={city}
      label={copy.cityLabel}
      placeholder={copy.cityPlaceholder}
      help={copy.cityHelp}
      onCityChange={onCityChange}
    />
  );
}
